import React from "react";

import Breadcrumbs from "../Breadcrumbs";
import PageHelp from "./MainTitle/PageHelp";
import { Skeleton } from "../../shadcn/components/ui/skeleton";

// Adapted from the @shadcndesign page-header-2 block (breadcrumbs, title,
// description, actions) and page-header-6 (leading avatar via `media`).
// The header sets the avatar size (the block's 56px) for every page, so a
// page passes a plain <Avatar> or <TeamAvatar> as `media`. The badge size
// needs `!`: AvatarBadge's own size rule has the same CSS weight.
const MEDIA_SIZE =
  "shrink-0 [&>[data-slot=avatar]]:size-14 [&_[data-slot=avatar-fallback]]:text-lg [&_[data-slot=avatar-badge]]:size-3.5! [&_[data-slot=avatar-badge]]:ring-2";
const PageHeader = ({
  title,
  subtitle,
  helpPageKey,
  actions,
  summary,
  breadcrumbs,
  media,
  meta,
  loading = false,
  bordered = true,
}) => (
  <header
    className={
      bordered
        ? "flex flex-col gap-6 border-b border-border py-4 md:py-6"
        : "flex flex-col gap-6 py-4 md:py-6"
    }
  >
    {breadcrumbs?.length ? <Breadcrumbs breadcrumbs={breadcrumbs} /> : null}
    <div className="flex flex-col justify-between gap-6 md:flex-row md:items-center">
      <div className="flex min-w-0 flex-col gap-3 md:flex-row md:items-center md:gap-4">
        {media ? <div className={MEDIA_SIZE}>{media}</div> : null}
        <div className="flex min-w-0 flex-col gap-1 break-words">
          {loading ? (
            <Skeleton aria-hidden="true" className="h-8 w-72 max-w-full" />
          ) : (
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">
              {title}
            </h1>
          )}
          {loading ? (
            <Skeleton aria-hidden="true" className="h-4 w-56 max-w-full" />
          ) : subtitle ? (
            <p className="text-sm text-muted-foreground lg:text-base">
              {subtitle}
            </p>
          ) : null}
          {meta}
          {helpPageKey ? <PageHelp pageKey={helpPageKey} /> : null}
        </div>
      </div>
      {actions || summary ? (
        <div className="flex flex-col gap-3 md:items-end">
          {actions ? (
            <div className="flex flex-wrap items-center gap-2">{actions}</div>
          ) : null}
          {summary}
        </div>
      ) : null}
    </div>
  </header>
);

export default PageHeader;
